import Dashboard from "@/components/Dashboard.vue";
import LogIn from "@/components/LogIn.vue";
import { createWebHistory } from "vue-router";
import { createRouter } from "vue-router";

const routes = [
  { path: "/login", name: "LogIn", component: LogIn },
  { path: "/dashboard", name: "DashBoard", component: Dashboard },
  { path: "/", redirect: "/login" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
